import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-wizard',
  templateUrl: './empty-wizard.component.html',
})
export class EmptyWizardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
